module.exports = __webpack_public_path__ + "static/img/icon_null.4f588b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/icon_null.png
// module id = bRlv
// module chunks = 1